import { Container } from "@/components/Container"
import { BuyCryptocurrency } from "@/components/dashboard/BuyCryptocurrency"
import { CryptoStocks } from "@/components/dashboard/CryptoStocks"
import { ExchangeBox } from "@/components/dashboard/ExchangeBox"
import { RecentActivities } from "@/components/dashboard/resent_activities/RecentActivities"
import { PageTitle } from "@/components/Layout/PageTitle"
import { memo } from "react"

const DashboardPageComponent = () => {
  return (
    <Container maxW={980}>
      <PageTitle title_id="dashboard" />
      <div className="flex items-stretch flex-col gap-0 md:!gap-10 md:flex-row">
        <BuyCryptocurrency />
        <CryptoStocks />
      </div>
      <div className="dashboard-info">
        <div className="flex items-stretch [&>div]:flex-grow-0 flex-col md:flex-row">
          <ExchangeBox />
          <RecentActivities />
        </div>
      </div>
    </Container>
  )
}

export const DashboardPage = memo(DashboardPageComponent)
